import { CksCheckoutStateSchema } from "@/services/cosmos/schema/checkout-service";
import { logError } from "@/services/logging/logger";
import type { CheckoutSession } from "@/types";

type MutateSessionFn = (
  data?: CheckoutSession | Promise<CheckoutSession>,
  opts?: { revalidate?: boolean },
) => Promise<CheckoutSession | undefined>;

/**
 * When `report-3ds-failure` returns 4xx (e.g. 409 in early-repayment / FDS:
 * "Can't report 3DS failure in status: AWAIT_EARLY_REPYAYMENT_COMPLETION"), the
 * BE has already updated the session from the payment provider redirect. Refetch
 * the session so `onSessionFetched` can run route correction (e.g. /early-repayment)
 * and the UI can show the payment error banner.
 */
export async function refetchCheckoutAfterFailed3dsReport(
  getSession: () => Promise<unknown>,
  mutateSession: MutateSessionFn,
  onSessionFetched: (session: CheckoutSession) => void,
): Promise<void> {
  try {
    const raw = await getSession();
    const fresh = CksCheckoutStateSchema.parse(raw);
    mutateSession(fresh, { revalidate: false });
    onSessionFetched(fresh);
  } catch (err) {
    logError(
      "refetch-after-failed-3ds-report",
      "Refetch after failed 3DS report also failed",
      err instanceof Error ? err : new Error(String(err)),
      { err },
    );
  }
}
